import request from '@/utils/request';
export function videoList(data) {
  return request.post('admin/tracback/video-list', data);
}
export function getCustomer(data) {
  return request.post('admin/customer/resource', data);
}
export function getVideoDetailData(data) {
  return request.post('admin/tracback/video-detail', data);
}